const translations = {
  selectAssets: 'Selección de activos',
  'errors.loadAll': 'Error al cargar todos los activos',
  'errors.loadAllMessage': 'Hubo un problema al cargar la lista completa de activos.',
  'errors.load': 'Error al cargar activos',
  'errors.loadMessage': 'Hubo un problema al cargar la lista de activos.'
}

export default translations
